var map = {
	"./audio-matching/l_k.json": 784,
	"./audio-matching/r_t.json": 672,
	"./audio-matching/s_k.json": 844,
	"./audio-matching/t_k.json": 24,
	"./ipa-matching/l_k.json": 588,
	"./ipa-matching/r_t.json": 380,
	"./ipa-matching/s_k.json": 208,
	"./ipa-matching/t_k.json": 216,
	"./vowel-matching/l_k.json": 130,
	"./vowel-matching/r_t.json": 296,
	"./vowel-matching/s_k.json": 344,
	"./vowel-matching/t_k.json": 992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;